module.exports = __webpack_public_path__ + "static/media/blackoutDay_listing_mobile.4027a4d8.jpg";